import { useEffect } from "react";
import { useParams } from "react-router-dom";

import styled from "styled-components/macro";

import { useNewSignupCreationFlow } from "Signups/SignupView/NewSignup";
import { signupItemStateHooks } from "Signups/SignupView/SignupSheet/Screens/SignupItems/stateHooks";
import { AnimatePresence, motion } from "framer-motion";

import EditSignupItemNav from "./EditSignupItemNav";
import { useIsNew } from "./EditSignupItemNav/statehooks";

export default function EditSignupItem() {
  const { signupItemID } = useParams();

  const { getSignupItem } = signupItemStateHooks.useGetSignupItem();

  const { forceToAddItem } = useNewSignupCreationFlow();

  const isNew = useIsNew();

  useEffect(() => {
    getSignupItem(signupItemID);
  }, [signupItemID, getSignupItem]);

  return (
    <Wrapper>
      <Inside>
        <AnimatePresence>
          {(isNew || forceToAddItem) && (
            <NewItemTitle
              initial={
                forceToAddItem
                  ? { opacity: 1, height: "auto" }
                  : { opacity: 0, height: 0 }
              }
              animate={{ opacity: 1, height: "auto" }}
              exit={{ opacity: 0, height: 0 }}
            >
              <NewItemTitleInside>
                Add {forceToAddItem ? "your first" : "a new"} item
              </NewItemTitleInside>
              <NewItemDescription>
                Fill out the information below to add items to your signup.
              </NewItemDescription>
            </NewItemTitle>
          )}
        </AnimatePresence>
        <EditSignupItemNav />
      </Inside>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  flex-grow: 1;
  z-index: 10;
  padding-left: 18px;
  padding-top: 8px;
  padding-right: 48px; // somehow this big padding-right fixes a horizontal scrollbar on the Info & Fund It tabs.
`;
const Inside = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
`;

const NewItemTitle = styled(motion.div)`
  overflow: hidden;
`;
const NewItemTitleInside = styled.div`
  font-size: 24px;
  font-weight: 400;
  padding-top: 8px;
`;
const NewItemDescription = styled.div`
  font-weight: 400;
  color: #828c8d;
  font-size: 15px;
  padding-bottom: 8px;
`;
